module.exports = __webpack_public_path__ + "img/defaultAvartar.96fd577e.png";